import React from "react";

const Loader = () => {
  return (
    <>
      <style jsx>{`
        .loader-container {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 80vh;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 9999;
        }

        .loader-backdrop {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: rgba(255, 255, 255, 0.95);
          opacity: 0.5;
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          z-index: 9998;
          animation: fadeIn 0.3s ease-out;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        .spinner-container {
          position: relative;
          width: 100px;
          height: 100px;
          margin-bottom: 24px;
        }

        .spinner-ring {
          position: absolute;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          border: 3px solid transparent;
        }

        .spinner-ring:nth-child(1) {
          border-top: 3px solid #7cc890;
          border-right: 3px solid #7cc890;
          animation: spin1 2s linear infinite;
          opacity: 1;
        }

        .spinner-ring:nth-child(2) {
          border-bottom: 3px solid #053251;
          border-left: 3px solid #053251;
          animation: spin2 2s linear infinite reverse;
          opacity: 0.8;
          transform: scale(0.8);
        }

        .spinner-ring:nth-child(3) {
          border-top: 2px solid rgba(124, 200, 144, 0.4);
          animation: spin1 3s linear infinite;
          opacity: 0.6;
          transform: scale(0.6);
        }

        @keyframes spin1 {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        @keyframes spin2 {
          0% {
            transform: scale(0.8) rotate(0deg);
          }
          100% {
            transform: scale(0.8) rotate(360deg);
          }
        }

        .spinner-center {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 24px;
          height: 24px;
          background: linear-gradient(135deg, #7cc890 0%, #6ab77d 100%);
          border-radius: 50%;
          animation: pulse 2s ease-in-out infinite;
          box-shadow: 0 0 20px rgba(124, 200, 144, 0.3);
        }

        @keyframes pulse {
          0%,
          100% {
            transform: translate(-50%, -50%) scale(1);
            box-shadow: 0 0 20px rgba(124, 200, 144, 0.3);
          }
          50% {
            transform: translate(-50%, -50%) scale(1.2);
            box-shadow: 0 0 30px rgba(124, 200, 144, 0.5);
          }
        }

        .loading-text {
          color: #053251;
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 8px;
          animation: textPulse 2s ease-in-out infinite;
          letter-spacing: 1px;
        }

        .loading-dots {
          color: #7cc890;
          font-size: 24px;
          font-weight: bold;
          animation: dots 2s ease-in-out infinite;
        }

        @keyframes textPulse {
          0%,
          100% {
            opacity: 0.7;
          }
          50% {
            opacity: 1;
          }
        }

        @keyframes dots {
          0%,
          20% {
            opacity: 0.2;
          }
          40% {
            opacity: 1;
          }
          100% {
            opacity: 0.2;
          }
        }

        .loading-progress {
          width: 120px;
          height: 4px;
          background: rgba(5, 50, 81, 0.1);
          border-radius: 2px;
          overflow: hidden;
          margin-top: 16px;
        }

        .loading-progress-bar {
          height: 100%;
          background: linear-gradient(
            90deg,
            #7cc890 0%,
            #6ab77d 50%,
            #7cc890 100%
          );
          border-radius: 2px;
          animation: progressMove 2s ease-in-out infinite;
        }

        @keyframes progressMove {
          0% {
            width: 0%;
            margin-left: 0%;
          }
          50% {
            width: 60%;
            margin-left: 20%;
          }
          100% {
            width: 0%;
            margin-left: 100%;
          }
        }

        /* Mobile Optimization */
        @media (max-width: 768px) {
          .spinner-container {
            width: 80px;
            height: 80px;
          }

          .loading-text {
            font-size: 16px;
          }

          .loading-progress {
            width: 100px;
          }
        }

        @media (max-width: 480px) {
          .spinner-container {
            width: 60px;
            height: 60px;
          }

          .loading-text {
            font-size: 14px;
          }

          .loading-progress {
            width: 80px;
          }
        }
      `}</style>

      <div className="loader-backdrop"></div>
      <div className="loader-container">
        {/* Main Spinner */}
        <div className="spinner-container">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-center"></div>
        </div>

        {/* Loading Text */}
        <div className="loading-text iran-sans">در حال بارگذاری</div>
        <div className="loading-dots">...</div>

        {/* Progress Bar */}
        <div className="loading-progress">
          <div className="loading-progress-bar"></div>
        </div>
      </div>
    </>
  );
};

export default Loader;
